<template>
  <div class="main-table-wrapper">
    <el-table :data="data" style="width: 100%">
      <el-table-column :label="$tc('form.name')" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.member ? `${scope.row.member.firstName} ${scope.row.member.lastName}` : '-' }}
        </template>
      </el-table-column>
      <el-table-column :label="$tc('general.club')" width="150">
        <template slot-scope="scope">
          {{ scope.row.club ? scope.row.club.shortName : '-' }}
        </template>
      </el-table-column>
      <el-table-column :label="$tc('seminar.positions')" min-width="200">
        <template slot-scope="scope">
          <span>{{ formatPositions(scope.row.positions) }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="canEdit" :label="$tc('general.actions')" width="120" align="right">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" size="small" circle @click="$emit('edit', scope.row)" />
          <el-button icon="el-icon-delete" size="small" type="danger" circle @click="beforeRemove(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
    canEdit: { type: Boolean, default: false },
    showClubName: { type: Boolean, default: false }
  },

  methods: {
    formatPositions (positions) {
      if (!positions || !positions.length) return '-'
      return positions.map(p => this.$t('seminar.' + p)).join(', ')
    },
    async beforeRemove (row) {
      try {
        await this.$confirm(this.$tc('general.confirm_delete', 0, { item: (row.member ? `${row.member.firstName} ${row.member.lastName}` : '') }))
        this.$emit('remove', row)
      } catch {}
    }
  }
}
</script>
